import { AUTH_API_URL, fmhNpiAPI } from 'api/APIBase';

export async function getUserProfile() {
    const url = `${AUTH_API_URL}/profile/prescriber`;
    return fmhNpiAPI({ url }).get().json();
}

export function updateProfile(profile) {
    const url = `${AUTH_API_URL}/profile/prescriber`;
    return fmhNpiAPI({ url })
        .put({
            prescriber_name: profile.fullName,
        })
        .json();
}
